import Event from "../event";
import {EventType} from "../../../gd/const/event"
// import ACLProject from "../../../gd/access-control/project/project";


export class EventAccessControl {

    private event : Event

    constructor(event:Event) {
        this.event = event
    }

    get hasAccess():boolean {
        return gd.ac.check.event.canEditEvent(this.event)
    }

    get hasAccessAndEventOpen():boolean {
        if (this.event.isAccomplished) return false

        return gd.ac.check.event.canEditEvent(this.event)
    }

    get canAddExpense() {
        return false
    }

    get canChangeDependency():boolean {
        return this.hasAccessAndEventOpen
    }

    get canChangeStartDate(): boolean {
        return this.hasAccessAndEventOpen
    }

    get canChangeEndDate(): boolean {
        const isAllowedByType = () => {
            switch (this.event.type) {
                case EventType.PROJECT_MILESTONE    : return false
                default                             : return true
            }
        }

        return this.hasAccessAndEventOpen && isAllowedByType()
    }

    get canChangeDuration():boolean {
        const isAllowedByType = () => {
            switch (this.event.type) {
                case EventType.PROJECT_MILESTONE    : return false
                default                             : return true
            }
        }

        return this.hasAccessAndEventOpen && isAllowedByType()
    }

    get canView():boolean {
        return this.hasAccess
    }

    get canRename():boolean {
        return this.hasAccess
    }

    get canViewHistory():boolean {
        return this.hasAccess
    }

    get canEdit():boolean {
        return this.hasAccess
    }
}
